module.exports = __webpack_public_path__ + "static/media/refresh.8da1bf11.svg";